import type { SvgIconProps } from './icon-props';

interface AlertProps extends SvgIconProps {
	fill?: string;
}

export default function Alert({
	height = 20,
	width = 21,
	fill = '#EA0A0A',
	svgPathClassName,
}: AlertProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 21 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="icons/other/alert">
				<path
					id="Mask"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M10.1836 0.625C5.00586 0.625 0.808594 4.82227 0.808594 10C0.808594 15.1777 5.00586 19.375 10.1836 19.375C15.3613 19.375 19.5586 15.1777 19.5586 10C19.5586 4.82227 15.3613 0.625 10.1836 0.625ZM10.1836 18.75C5.35105 18.75 1.43359 14.8325 1.43359 10C1.43359 5.16746 5.35105 1.25 10.1836 1.25C15.0161 1.25 18.9336 5.16746 18.9336 10C18.9336 14.8325 15.0161 18.75 10.1836 18.75Z"
					fill={fill}
					className={svgPathClassName}
				/>
				<path
					id="!"
					d="M10.185 13.4729C9.76354 13.4729 9.42188 13.8146 9.42188 14.236C9.42188 14.6575 9.76354 14.9991 10.185 14.9991C10.6065 14.9991 10.9481 14.6575 10.9481 14.236C10.9481 13.8146 10.6065 13.4729 10.185 13.4729ZM10.8381 8.20664V5.18164H9.53187V8.20664L9.87563 11.8579H10.4944L10.8381 8.20664Z"
					fill={fill}
					className={svgPathClassName}
				/>
			</g>
		</svg>
	);
}
